import type {
  AddressSearchParams,
  BranchFilters,
  CargoTypeFilters,
  CarrierCodeFilters,
  CarrierFilters,
  CarrierServiceFilters,
  CitiesParams,
  ClassFilters,
  CurrencyFilters,
  CustomerFilters,
  DirectInterlineFilters,
  EquipmentTypeFilters,
  LaneItem,
  LanesParams,
  LinerTypeFilters,
  LocationsParams,
  PortNameFilters,
  PortsParams,
  PortTypeFilters,
  PostalsParams,
  PricingCategoryFilters,
  PricingTypeFilters,
  ProductsParams,
  ProviderSearchParams,
  ShipTypeFilters,
  StatesParams,
  SupplierDiversityFilters,
  TariffTypeFilters,
  TransportationModeFilters,
  TransportTypeFilters,
} from './models';
import type { CompanyUsersFilters } from './models/company-users.model';

export const CACHE_KEYS = {
  addressBookSearch: (params: AddressSearchParams) => [...CACHE_KEYS.all, 'addressBookSearch', params] as const,
  addressById: (id: string) => [...CACHE_KEYS.all, 'address', id],
  all: ['entities'] as const,
  branches: (filters: Partial<BranchFilters> = {}) => [...CACHE_KEYS.all, 'branches', filters] as const,
  cargoTypes: (filters: Partial<CargoTypeFilters> = {}) => [...CACHE_KEYS.all, 'cargoTypes', filters] as const,
  carrierCodes: (filters: Partial<CarrierCodeFilters> = {}) => [...CACHE_KEYS.all, 'carrierCodes', filters] as const,
  carrierServices: (filters: Partial<CarrierServiceFilters> = {}) =>
    [...CACHE_KEYS.all, 'carrierServices', filters] as const,
  carriers: (filters: Partial<CarrierFilters> = {}) => [...CACHE_KEYS.all, 'carriers', filters] as const,
  cities: (params: CitiesParams) => [...CACHE_KEYS.all, 'cities', params] as const,
  classes: (filters: Partial<ClassFilters> = {}) => [...CACHE_KEYS.all, 'classes', filters] as const,
  companies: () => [...CACHE_KEYS.all, 'companies'] as const,
  companyUsers: (filters: CompanyUsersFilters) => [...CACHE_KEYS.all, 'companyUsers', filters] as const,
  contractStatuses: (filters: { companyId: string }) => [...CACHE_KEYS.all, 'contractStatuses', filters] as const,
  countries: () => [...CACHE_KEYS.all, 'countries'] as const,
  currencies: (filters: Partial<CurrencyFilters> = {}) => [...CACHE_KEYS.all, 'currencies', filters] as const,
  customers: (filters: Partial<CustomerFilters> = {}) => [...CACHE_KEYS.all, 'customers', filters] as const,
  directInterlines: (filters: Partial<DirectInterlineFilters> = {}) =>
    [...CACHE_KEYS.all, 'directInterlines', filters] as const,
  equipmentTypes: (filters: Partial<EquipmentTypeFilters> = {}) =>
    [...CACHE_KEYS.all, 'equipmentTypes', filters] as const,
  lane: (laneKey: LaneItem['laneKey']) => [...CACHE_KEYS.all, 'lanes', laneKey] as const,
  lanes: (params: LanesParams) => [...CACHE_KEYS.all, 'lanes', params] as const,
  linerTypes: (filters: Partial<LinerTypeFilters> = {}) => [...CACHE_KEYS.all, 'linerTypes', filters] as const,
  locations: (params: LocationsParams) => [...CACHE_KEYS.all, 'locations', params] as const,
  lookupCodes: () => [...CACHE_KEYS.all, 'lookupCodes'] as const,
  portNames: (filters: Partial<PortNameFilters> = {}) => [...CACHE_KEYS.all, 'portNames', filters] as const,
  ports: (params: PortsParams) => [...CACHE_KEYS.all, 'ports', params] as const,
  portTypes: (filters: Partial<PortTypeFilters> = {}) => [...CACHE_KEYS.all, 'portTypes', filters] as const,
  postals: (params: PostalsParams) => [...CACHE_KEYS.all, 'postals', params] as const,
  pricingCategories: (filters: Partial<PricingCategoryFilters> = {}) =>
    [...CACHE_KEYS.all, 'pricingCategories', filters] as const,
  pricingTypes: (filters: Partial<PricingTypeFilters> = {}) => [...CACHE_KEYS.all, 'pricingTypes', filters] as const,
  products: (params: ProductsParams) => [...CACHE_KEYS.all, 'products', params] as const,
  providers: (params: ProviderSearchParams) => [...CACHE_KEYS.all, 'providers', params] as const,
  shipTypes: (filters: Partial<ShipTypeFilters> = {}) => [...CACHE_KEYS.all, 'shipTypes', filters] as const,
  states: (params: StatesParams) => [...CACHE_KEYS.all, 'states', params] as const,
  supplierDiversities: (filters: Partial<SupplierDiversityFilters> = {}) =>
    [...CACHE_KEYS.all, 'supplierDiversities', filters] as const,
  tariffTypes: (filters: Partial<TariffTypeFilters> = {}) => [...CACHE_KEYS.all, 'tariffTypes', filters] as const,
  timeZones: () => [...CACHE_KEYS.all, 'timeZones'] as const,
  transportationModes: (filters: Partial<TransportationModeFilters> = {}) =>
    [...CACHE_KEYS.all, 'transportationModes', filters] as const,
  transportTypes: (filters: Partial<TransportTypeFilters> = {}) =>
    [...CACHE_KEYS.all, 'transportTypes', filters] as const,
} as const;
